import { Tooltip } from "bootstrap";
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { BaseElement } from "./BaseElement.js";

@customElement("ac101-tooltip")
export class AC101Tooltip extends BaseElement {
  @property({ type: String }) tooltip: string;
  @property({ type: String }) placement = "right";
  async firstUpdated() {
    new Tooltip(this, {
      placement: this.placement as Tooltip.PopoverPlacement,
      title: this.tooltip,
      customClass: "ac101-tooltip",
      html: true,
    });
  }

  render() {
    return html`<slot></slot> `;
  }
}
